
export default function Footer() {
    return (
        <div className="app-footer">
            <span>© Precision X Technology 2023</span>
        </div>
    );
}